import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Autumn/PlaceValue/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValue',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/1RomanNumeralsTo1000" */ './1RomanNumeralsTo1000'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/2NumbersTo10000" */ './2NumbersTo10000'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/3NumbersTo100000" */ './3NumbersTo100000'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/4NumbersTo1000000" */ './4NumbersTo1000000'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/5ReadAndWriteNumbersTo1000000" */ './5ReadAndWriteNumbersTo1000000'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year5/Autumn/PlaceValue/6PowersOf10" */ './6PowersOf10')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/7To100000MoreOrLess" */ './7To100000MoreOrLess'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/8PartitionNumbersTo1000000" */ './8PartitionNumbersTo1000000'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/9NumberLineTo1000000" */ './9NumberLineTo1000000'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/10CompareAndOrderNumbersTo100000" */ './10CompareAndOrderNumbersTo100000'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/11CompareAndOrderNumbersTo1000000" */ './11CompareAndOrderNumbersTo1000000'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/12RoundToTheNearest10100Or1000" */ './12RoundToTheNearest10100Or1000'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/13RoundWithin100000" */ './13RoundWithin100000'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/PlaceValue/14RoundWithin1000000" */ './14RoundWithin1000000'
        )
    })
  ]
});
export default Block;
